/**
 * 基础配置
 */
export default {
  
}